@if (hasError()) {
  <div class="flex items-center gap-2 pl-10 pt-12 text-2xl text-red-600">
    <mat-icon fontSet="material-symbols-outlined">{{ iconClass() }}</mat-icon>
    <span>{{ errorMessage() }}</span>
  </div>
} @else {
  <div class="flex items-center gap-2 pl-10 pt-12 text-2xl text-gray-900">
    <mat-icon fontSet="material-symbols-outlined" class="spinner-icon"
      >progress_activity</mat-icon
    >
    <span>Downloading</span>
  </div>
}
